import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import HubSpotIcon from '../../images/hubspot.png'
import MarketoIcon from '../../images/marketo.png'
import IntercomIcon from '../../images/intercom.png'
import ShopifyIcon from '../../images/shopify.png'
import PodiumIcon from '../../images/podium.png'
import WixIcon from '../../images/wix.png'
import BigCommerceIcon from '../../images/bigcommerce.png'
import SquareUpIcon from '../../images/squareup.png'
import SquareSpaceIcon from '../../images/squarespace.png'
import Shift4ShopIcon from '../../images/shift4shop.png'
import WebsiteIcon from '../../images/website.png'

function ApplicationCard03(props) {

  const [loading, setLoading] = useState(false)

  const handleIcon = (id) => {
    switch (id) {
      case 'Website':
        return (
          <img className="rounded-full bg-white" src={WebsiteIcon} width="100" height="100" alt={props.appName} />
        );
      case 'HubSpot':
        return (
          <img className="rounded-full bg-white" src={HubSpotIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Marketo':
        return (
          <img className="rounded-full bg-white" src={MarketoIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Intercom':
        return (
          <img className="rounded-full bg-white" src={IntercomIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Shopify':
        return (
          <img className="rounded-full bg-white" src={ShopifyIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Podium':
        return (
          <img className="rounded-full bg-white" src={PodiumIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Wix':
        return (
          <img className="rounded-full bg-white" src={WixIcon} width="100" height="100" alt={props.appName} />
        );
      case 'BigCommerce':
        return (
          <img className="rounded-full bg-white" src={BigCommerceIcon} width="100" height="100" alt={props.appName} />
        );
      case 'SquareUp':
        return (
          <img className="rounded-full bg-white" src={SquareUpIcon} width="100" height="100" alt={props.appName} />
        );
      case 'SquareSpace':
        return (
          <img className="rounded-full bg-white" src={SquareSpaceIcon} width="100" height="100" alt={props.appName} />
        );
      case 'Shift4Shop':
        return (
          <img className="rounded-full bg-white" src={Shift4ShopIcon} width="100" height="100" alt={props.appName} />
        );
      case 1:
        return (
          <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
            <circle className="text-light-blue-200" cx="15" cy="15" r="9" fillRule="nonzero" />
            <circle className="text-light-blue-400" cx="9" cy="9" r="9" />
          </svg>
        );
      case 2:
        return (
          <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
            <path className="text-green-400" d="M23.864 4.45L19.553.139l-2.337 4.663 1.98 1.98zM4.802 6.784l1.979-1.979L4.45.136.139 4.447z" />
            <path className="text-green-200" d="M4 15.385V8.619L0 6.614v10.769z" />
            <path className="text-green-500" d="M8.414 6L6 8.414v7.172L8.414 18h7.172L18 15.586V8.414L15.586 6z" />
            <path className="text-green-200" d="M8.615 4h6.766l2.005-4H6.617z" />
            <path className="text-green-400" d="M6.784 19.198l-1.98-1.98L.136 19.55l4.311 4.311z" />
            <path className="text-green-200" d="M20 8.615v6.766l4 2.005V6.617z" />
            <path className="text-green-400" d="M19.198 17.216l-1.979 1.979 2.331 4.669 4.311-4.311z" />
            <path className="text-green-200" d="M15.385 20H8.619l-2.005 4h10.769z" />
          </svg>
        );
      case 3:
        return (
          <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
            <path className="text-red-100" d="M12 10l12 7-12 7-12-7z" />
            <path className="text-red-300" d="M12 5l12 7-12 7-12-7z" />
            <path className="text-red-500" d="M12 0l12 7-12 7L0 7z" />
          </svg>
        );
      default:
        return;
    }
  };

  return (
    <div className="col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-lg rounded-sm border border-gray-200">
      <div className="flex flex-col h-full text-center p-5">
        <div className="flex-grow mb-1">
          <div className="inline-flex justify-center items-center w-16 h-16 bg-gray-100 rounded-full mb-2">
            {handleIcon(props.title)}
          </div>
          <h3 className="text-lg text-gray-800 font-semibold mb-1">{props.title}</h3>
        </div>
        <div>
          {
            loading?
                <div className="sm:flex justify-items-center mt-2 w-full">
                  <div className="m-auto">
                    <svg className="animate-spin h-6 w-6" viewBox="0 0 100 100">
                      <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                              strokeDasharray="283" strokeDashoffset="75"/>
                    </svg>
                  </div>
                </div>:
            props.title==='HubSpot'||props.title==='Intercom'||props.title==='Wix'
          ||props.title==='BigCommerce'||props.title==='SquareUp'||props.title==='Shopify'
          ||props.title==='SquareSpace'||props.title==='Website'
            ?<button className={`${props.isActive ? 'bg-red-500 hover:bg-red-700' : 'bg-yellow-500 hover:bg-yellow-700'}
           text-xs text-white font-bold py-2 px-4 rounded-full`}
                   onClick={() => {
                     props.onClick(props.integrationId, props.activeId, props.title, props.isActive, props.userDetails,
                         props.authToken)
                     setLoading(true)
                   }
            }>{props.isActive ? 'Disconnect' : 'Connect'}</button>:
          'Coming Soon 👀'}
        </div>
      </div>
    </div>
  );
}

export default ApplicationCard03;